<template>
  <div class="row">
    <div class="col-md-12">
      <TableWrapper
        name="tbl_temporary_deposit"
        :columns="columns"
        :url="url"
        :mod-count="modCount"
        :search-form-fields="formFields"
        :offset-height="offsetHeight"
        :show-column-visible="true"
        :show-add="false"
        @on-ready="onReady"
      />
    </div>
  </div>
</template>

<script>
import TableWrapper from '@/components/table-wrapper'
import request from '@/utils/request'
import { getLinkTextStyle } from '@/utils/util'
import { isAdmin, hasPermission } from '@/utils/app'
export default {
  name: 'TemporaryUserDeposit',
  components: {
    TableWrapper
  },
  data() {
    return {
      modCount: 0,
      garages: this.loadGarages(),
      url: this.$config.apiContextPath + '/temporary/deposit'
    }
  },
  computed: {
    refundPermitted() { return isAdmin() || hasPermission('PEM_MEMBER_TEMP_DEPOSIT_REFUND') },
    offsetHeight() {
      return 270
    },
    formFields() {
      return {
        action: '',
        fields: [
          { label: '充值日期', width: '190px', options: {
            shortcuts: [
              {
                text: '一周',
                value() {
                  const end = new Date()
                  const start = new Date()
                  start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
                  return [start, end]
                }
              },
              {
                text: '一个月',
                value() {
                  const end = new Date()
                  const start = new Date()
                  start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
                  return [start, end]
                }
              },
              {
                text: '三个月',
                value() {
                  const end = new Date()
                  const start = new Date()
                  start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
                  return [start, end]
                }
              }
            ]
          }, placeholder: '请选择缴费日期...', type: 'dateranger' },
          // { label: '临停车库', placeholder: '请选择临停车库...', name: 'parkingId', width: '120px', type: 'select', options: this.garages },
          { label: '用户手机', placeholder: '请输入用户手机...', name: 'mobile', width: 'auto', type: 'input' },
          { label: '临停用户', placeholder: '请输入临停用户...', name: 'member', width: 'auto', type: 'input' },
          { label: '状态', placeholder: '请选择状态', name: 'status', width: '100px', type: 'select', options: [
            { label: '已缴纳', value: 1 },
            { label: '已退费', value: 2 }]
          }
        ]
      }
    },
    columns() {
      const _this = this
      return [
        { title: '序号', type: 'index', width: 80, align: 'center', key: '_index', disabled: true },
        // { title: '临停车库', align: 'center', key: 'parking', sortable: true, width: 200 },
        { title: '临停用户', align: 'left', key: 'member', sortable: true, width: 230,
          render: (h, params) => {
            return h('span', {}, params.row.member || '---')
          }
        },
        { title: '用户手机', align: 'center', key: 'mobile', sortable: true, width: 230 },
        { title: '缴费时间', align: 'center', key: 'payTime', sortable: true,
          render: (h, params) => {
            return h('span', {}, params.row.payTime || '---')
          }
        },
        { title: '押金状态', align: 'center', key: 'status', sortable: true, width: 120,
          render: (h, params) => {
            return h('span', {
              style: { color: params.row.status === 1 ? 'green' : (params.row.status === 0 ? '#000' : (params.row.status === 2 ? 'red' : 'blue')) }
            }, params.row.status === 1 ? '已缴纳' : (params.row.status === 0 ? '未缴纳' : (params.row.status === 2 ? '已退费' : '--')))
          }
        },
        { title: '操作', align: 'center', width: 180, disabled: true, key: '_actions',
          render: (h, params) => {
            return h('div', [
              h('a', {
                style: getLinkTextStyle(_this.refundPermitted),
                on: {
                  click: () => {
                    if (params.row.id && _this.refundPermitted && params.row.status === 1) { // && params.row.depositPaid === 1) {
                      this.showRefundModalDialog(params.row.id, params.row.mobile)
                    }
                  }
                }
              }, [
                h('i', { class: { 'fas': true, 'fa-undo': true, 'cell-icon-link': true }}),
                h('span', {
                  domProps: {
                    title: _this.deletePermitted ? (params.row.status === 1 ? '押金退款' : '押金已退') : '您没有权限退押金'
                  }
                }, '退押金')
              ])
            ])
          }
        }
      ]
    }
  },
  methods: {
    async loadGarages() {
      await request({
        url: this.$config.apiContextPath + '/parking/list',
        method: 'get'
      }).then(res => {
        this.garages = []
        const items = res.data
        items.forEach(i => {
          this.garages.push({ label: i.name, value: i.id })
        })
      }).catch(error => {
        console.log(error)
        this.garages = []
      })
    },
    async onReady(data, params) {
    },
    showRefundModalDialog: function(id, mobile) {
      const _this = this
      this.$Modal.confirm({
        title: '确认退款临停押金么？',
        loading: true,
        render: (h, params) => {
          return h('ul', { style: { padding: '10px 25px 0' }}, [h('li', {}, mobile)])
        },
        onOk: function() {
          const _that = this
          request({
            url: _this.url + '/' + id + '/action/refund',
            method: 'PUT'
          }).then(res => {
            this.$Notice.success({
              title: '临停押金退款成功',
              desc: '临停用户 `' + mobile + '` 押金退款成功!'
            })
            _this.modCount = _this.modCount + 1
            this.$Modal.remove()
          }).catch(error => {
            this.$Notice.error({
              title: '临停押金退款失败',
              desc: '临停用户 `' + mobile + '` 押金退款失败, 错误信息: ' + error
            })
            _that.buttonLoading = false
          })
        }
      })
    }
  }
}
</script>

